export class WFCEvent {
    constructor(type, data = null) {
        this.type = type;
        this.data = data;
    }
}
